module.exports = __webpack_public_path__ + "img/Elastic-Stack.5fdf2a3.svg";